import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MoreIcon from '@rsuite/icons/More';
import SortDownIcon from '@rsuite/icons/SortDown';
import TrashIcon from '@rsuite/icons/Trash';
import globalIP from '../../GlobelIP';
import VisibleIcon from '@rsuite/icons/Visible';
import CloudReflashIcon from '@rsuite/icons/CloudReflash';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import EmailIcon from '@rsuite/icons/Email';
import LoadingBar from 'react-top-loading-bar';
import imger from '../../assets/images/items/whatsapp.svg';
import CopyToClipboard from 'react-copy-to-clipboard';
import GearIcon from '@rsuite/icons/Gear';
import './style.css';
import MenuIcon from '@rsuite/icons/Menu';
import {
  Input,
  InputGroup,
  Modal,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  useToaster,
  SelectPicker,
  IconButton,
  Table,
  Whisper,
  Pagination,
  FlexboxGrid,
  Loader,
  Message,
  Tooltip,
  Checkbox,
  Badge,
  Dropdown
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';
import EditIcon from '@rsuite/icons/Edit';
import ManageCatalogueSlider from './ManageCatalogueSlider';
import ugr from '@/UGRoute';
import ViewModal from '@/components/ViewModal';
import ShowDimensionModal from '@/components/ShowDimensionModal';
import Email from '@/components/Email';
import WhatsApp from '@/components/WhatsApp';
import Footer from '@/components/Footer/Footer';
import AddedOnFIlter from '@/components/AddedOnFilter';
import useUser from '../../components/UseUser';
import DeleteModal from './bulkActions/DeleteModal';
import ActiveInacitve from './bulkActions/ActiveInacitve';
import { LinkOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';
import GenerateAuthSlider from '../catalogue/GenerateAuthSlider';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const { Column, HeaderCell, Cell } = Table;

const MaybeCheckCell = ({ show, ...props }: any) => {
  if (!show) return null;
  // Spread props to RSuite's CheckCell
  return <CheckCell {...props} />;
};

const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey]}
        inline
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
      />
    </div>
  </Cell>
);

const CompactCell = props => <Cell {...props} style={{ padding: 6 }} />;
const ManageCatalogue = () => {
  const { user } = useUser();
  const ipp = globalIP;
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Trash');
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const [manageCatlougeOpen, setManageCatlougeOpen] = useState(false);
  const [updateClientAuthData, setUpdateClientAuthData] = useState();
  const [cataloguedata, setCatalogueData] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [metaview, setMetaView] = useState<MetaData>();
  const [metaedit, setMetaEdit] = useState<MetaData>();
  const [productData, setProductData] = useState([]);
  const [data1, setData1] = useState([]);
  const [buyeerdata, setBuyeerdata] = useState([]);
  const [buyeerCompNamedata, setBuyeerCompNamedata] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [foundProductCount, setFoundProductCount] = useState(0);
  const [searchQuery1, setSearchQuery1] = useState('');

  // const [searchQryBtn, setSearchQryBtn] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('');
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const [selectedBuyerName, setSelectedBuyerName] = useState('');
  const [selectedBuyerCompName, setSelectedBuyerCompName] = useState('');
  const [userName, setUserName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fetchProducts1, setFetchedProducts] = useState([]);
  const [productalldata, setProductAlldata] = useState([]);
  const [cataname, setCataname] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [progress, setProgress] = useState(0);
  const [page, setPage] = useState(1);
  const [cataloguedatat, setCatalogueDatat] = useState([]);
  const [isLoadingt, setIsLoadingt] = React.useState(false);
  const [pageview, setPageView] = useState(1);
  const [pageedit, setPageEdit] = useState(1);
  const [reload, setReload] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [fullname, setFullname] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  const [delteModal, setDeleteModal] = useState(false);
  const [activeInModal, setActiveInModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  let setSearchQryBtn = false;
  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  //**generate link for catalogue */
  const [openGenerateSlider, setOpenGenerateSlider] = useState(false);
  const [selectedCatalogueCode, setSelectedCatalogueCode] = useState("");
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [linkGenrate, setLinkGenrate] = useState();
  useEffect(() => {
    fetchData5();
  }, []);
  const fetchData5 = async () => {
    if (isLoadingcolor) {
      return;
    }
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${ipp}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ipp}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));
        allData.push(...processedData);
      }
      setColordata(allData);
      setIsLoadingcolor(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleUpdatedDatechange = value => {
    setFilteredData([]);

    setSelectedUpdatedDateRange(value);
  };

  useEffect(() => {
    const fetchAndProcessCatalogueData = async () => {
      try {
        const response = await fetch(
          `${ipp}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${updateCatalogue}`
        );
        const json = await response.json();
        const CatalogueProduct = json.data[0].attributes.CatalogueProduct;

        const ProductSizes = json.data[0].attributes.ProductSizes;
        fetchProducts1.map(item => {
          // Find the corresponding CatalogueProduct object using CatalogProduct as the key
          const matchedProduct = CatalogueProduct.find(
            prod => prod.CatalogProduct === String(item.id)
          );

          if (matchedProduct) {
            // Update the fields of data1234 item based on the matched CatalogueProduct
            item.attributes.CategoryName = matchedProduct.catcd;
            item.attributes.ProductTypeName = matchedProduct.prodtypecd;
            item.attributes.ProductId = matchedProduct.aliascd;
            item.attributes.ProductName = matchedProduct.productname;
            item.attributes.Description = matchedProduct.description;
            item.attributes.SizeUnit = matchedProduct.unit;
            item.attributes.Length = matchedProduct.len;
            item.attributes.Width = matchedProduct.wid;
            item.attributes.Height = matchedProduct.thick;
            item.attributes.FinishName = matchedProduct.finish;
            item.attributes.ColorName = matchedProduct.color;
            item.attributes.NetWeight = matchedProduct.netwgt;
            item.attributes.GrossWeight = matchedProduct.grswgt;
            item.attributes.SellingPrice = matchedProduct.saleprice;
            item.attributes.SellingPriceCurrency = matchedProduct.currency;
            item.attributes.Product_Remark = matchedProduct.remark;
            item.attributes.cbm = matchedProduct.cbm;
            item.attributes.SizeRange = matchedProduct.SizeRange;
          }
          return item;
        });

        // Update the state with the modified data
        // setData1234(updatedData);
        fetchProducts1.map(item => {
          const matchedSizes = ProductSizes.filter(size => {
            return size.CatalogueProduct == item.attributes.ProductId;
          });
          matchedSizes.forEach(item => {
            const color = colordata.find(colorItem => colorItem.value === item.ColorCode);
            if (color) {
              item.ColorName = color.label; // Add ColorName to the item
            }
            item.SizeUnit = item.Unit; // Add ColorName to the item
          });

          if (matchedSizes.length > 0) {
            item.attributes.SetSizes = matchedSizes;
          }
        });

        // setData1234(data1234temp)
      } catch (error) {
        console.error('Error:', error);
      }
    };
    fetchAndProcessCatalogueData();
  }, [fetchProducts1]);

  const handleOpen = (value, buyerEmail, BuyerCompany) => {
    setSize(value);
    setOpen(true);
    setTo(buyerEmail);
    setSubject('Regarding for Query');
    setMessage('Hello ' + BuyerCompany);
  };
  const handleClose = () => setOpen(false);
  const toaster = useToaster();

  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));

  const handleOptionChange = value => {
    setSelectedOption(value);
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchData();
  }, [page, pageedit, reload]);

  // -------------------- SEARCH & FILTER STATES --------------------
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  // Debounce for smoother typing
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery.trim());
    }, 150);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Fetch data when these dependencies change
  useEffect(() => {
    fetchData();
  }, [debouncedSearchQuery, page, pageedit, reload, selectedOption, selectedDateRange, selectedUpdatedDateRange, userName, selectedBuyerName, selectedBuyerCompName, linkGenrate]);

  // -------------------- MAIN FETCH FUNCTION --------------------
  const fetchData = async () => {
    if (isLoading) return;
    setIsLoading(true);
    setProgress(25);
    try {
      // ---------- Filters ----------
      const buyerNameFilter =
        selectedBuyerName?.length > 0
          ? `&filters[BuyerName][$eq]=${encodeURIComponent(selectedBuyerName)}`
          : '';
      const buyerCompanyNameFilter =
        selectedBuyerCompName?.length > 0
          ? `&filters[BuyerCompany][$eq]=${encodeURIComponent(selectedBuyerCompName)}`
          : '';

      const createdByFilter =
        userName?.length > 0
          ? `&filters[CreateBy][$eq]=${encodeURIComponent(userName)}`
          : '';

      const statusFilter =
        selectedOption?.length > 0
          ? `&filters[Status][$eq]=${encodeURIComponent(selectedOption)}`
          : '';

      // ---------- Search ----------
      const searchValue = debouncedSearchQuery?.trim() || '';
      const s = encodeURIComponent(searchValue);
      const searchQryFilter =
        searchValue.length > 0
          ? `&filters[$or][0][catalogueName][$containsi]=${s}` +
          `&filters[$or][1][BuyerCompany][$containsi]=${s}` +
          `&filters[$or][2][CPerson][$containsi]=${s}`
          : '';

      // ---------- Date & Updated Date Filters ----------
      const formatDateToISO = (date) => date.toISOString();

      const getFirstDayOfWeek = (date) => {
        const firstDay = new Date(date);
        firstDay.setDate(date.getDate() - firstDay.getDay());
        firstDay.setHours(0, 0, 0, 0);
        return formatDateToISO(firstDay);
      };

      const getFirstDayOfMonth = (date) => {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay.setHours(0, 0, 0, 0);
        return formatDateToISO(firstDay);
      };

      const getFirstDayOfLastMonth = (date) => {
        const first = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        first.setHours(0, 0, 0, 0);
        return formatDateToISO(first);
      };

      const getLastDayOfLastMonth = (date) => {
        const last = new Date(date.getFullYear(), date.getMonth(), 0);
        last.setHours(23, 59, 59, 999);
        return formatDateToISO(last);
      };

      const getDateDaysAgo = (date, days) => {
        const d = new Date(date);
        d.setDate(date.getDate() - days);
        d.setHours(0, 0, 0, 0);
        return formatDateToISO(d);
      };

      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0));
      const endOfToday = new Date();

      let datefilter = '';
      let updateddatefilter = '';

      // Created Date Filter
      switch (selectedDateRange) {
        case 'Today':
          datefilter = `&filters[createdAt][$gte]=${formatDateToISO(startOfToday)}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;
        case 'Yesterday':
          datefilter = `&filters[createdAt][$eq]=${getDateDaysAgo(new Date(), 1)}`;
          break;
        case 'This week':
          datefilter = `&filters[createdAt][$gte]=${getFirstDayOfWeek(new Date())}`;
          break;
        case 'Last week':
          const lastWeekStart = new Date();
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
          datefilter = `&filters[createdAt][$gte]=${formatDateToISO(lastWeekStart)}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'This month':
          datefilter = `&filters[createdAt][$gte]=${getFirstDayOfMonth(new Date())}`;
          break;
        case 'Last month':
          datefilter = `&filters[createdAt][$gte]=${getFirstDayOfLastMonth(new Date())}&filters[createdAt][$lte]=${getLastDayOfLastMonth(new Date())}`;
          break;
        case 'Last 3 month':
          const threeMonthsAgo = new Date();
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          datefilter = `&filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;
        case 'Last 6 month':
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          datefilter = `&filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;
        default:
          break;
      }

      // Updated Date Filter
      switch (selectedUpdatedDateRange) {
        case 'Today':
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(startOfToday)}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;
        case 'Yesterday':
          updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(new Date(), 1)}`;
          break;
        case 'This week':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(new Date())}`;
          break;
        case 'Last week':
          const lastWeekStart2 = new Date();
          lastWeekStart2.setDate(today.getDate() - today.getDay() - 7);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(lastWeekStart2)}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'This month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(new Date())}`;
          break;
        case 'Last month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(new Date())}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(new Date())}`;
          break;
        case 'Last 3 month':
          const threeMonthsAgo2 = new Date();
          threeMonthsAgo2.setMonth(today.getMonth() - 3);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo2)}`;
          break;
        case 'Last 6 month':
          const sixMonthsAgo2 = new Date();
          sixMonthsAgo2.setMonth(today.getMonth() - 6);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo2)}`;
          break;
        default:
          break;
      }

      // ---------- Build URL ----------
      const base = `${ipp}/api/catalogues?populate=*&pagination[page]=${page}&sort[0]=id:desc`;
      const url =
        selectedOption === 'Trash'
          ? `${base}&filters[Status][$ne]=Trash${buyerNameFilter}${buyerCompanyNameFilter}${createdByFilter}${searchQryFilter}${updateddatefilter}`
          : `${base}${buyerNameFilter}${buyerCompanyNameFilter}${createdByFilter}${statusFilter}${searchQryFilter}${updateddatefilter}`;

      // ---------- Fetch ----------
      const response = await fetch(url);
      const json = await response.json();
      setProgress(60);

      // reset page if empty (keep pagination consistent)
      if ((json.data?.length ?? 0) === 0 && page > 1) {
        setPage(1);
        return;
      }

      // ---------- Product fetch ----------
      setIsLoading1(true);
      const productResponse = await fetch(
        `${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${pageedit}`
      );
      const productJson = await productResponse.json();
      setMetaEdit(productJson.meta);
      setProductData(productJson.data);
      setIsLoading1(false);

      // ---------- Process Data ----------
      const updatedCatalogueData = (json.data || []).map(item => ({
        ...item,
        itemCount: item.attributes?.CatalogueProduct?.length || 0,
      }));

      setMeta123(json.meta);
      setFilteredData(updatedCatalogueData);
      setCatalogueData(updatedCatalogueData);

      setProgress(100);
    } catch (err) {
      console.error('fetchData error', err);
    } finally {
      setIsLoading(false);
    }
  };
  //**old function break seaching and other filter */
  // const fetchData = async () => {
  //   setProgress(30);
  //   if (isLoading) {
  //     return;
  //   }
  //   setIsLoading(true);
  //   let buyerNameFilter = '';
  //   if (selectedBuyerName.length > 0) {
  //     buyerNameFilter = `&filters[BuyerCompany][$eq]=${selectedBuyerName}`;
  //   }
  //   let createdByFilter = '';
  //   if (userName.length > 0) {
  //     createdByFilter = `&filters[CreateBy][$eq]=${userName}`;
  //   }
  //   let statusFilter = '';
  //   if (selectedOption.length > 0) {
  //     statusFilter = `&filters[Status][$eq]=${selectedOption}`;
  //   }
  //   let searchQryFilter = '';
  //   const searchValue = debouncedSearchQuery?.trim() || '';

  //   if (searchQuery.length > 0) {
  //     let searchQryy = searchQuery.trim();
  //     const searchQry = `filters[$or][0][catalogueName][$containsi]=${searchValue}&filters[$or][1][BuyerCompany][$containsi]=${searchQryy}&filters[$or][2][CPerson][$containsi]=${searchQryy}`;
  //     searchQryFilter = `&${searchQry}`;
  //   }

  //   let datefilter = '';
  //   let updateddatefilter = '';
  //   const formatDateToISO = date => date.toISOString();

  //   const getFirstDayOfWeek = date => {
  //     const firstDay = new Date(date);
  //     firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
  //     firstDay.setHours(0, 0, 0, 0);
  //     return formatDateToISO(firstDay);
  //   };

  //   const getFirstDayOfMonth = date => {
  //     const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  //     firstDay.setHours(0, 0, 0, 0);
  //     return formatDateToISO(firstDay);
  //   };

  //   const getFirstDayOfLastMonth = date => {
  //     const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  //     firstDayOfLastMonth.setHours(0, 0, 0, 0);
  //     return formatDateToISO(firstDayOfLastMonth);
  //   };

  //   const getLastDayOfLastMonth = date => {
  //     const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
  //     lastDayOfLastMonth.setHours(23, 59, 59, 999);
  //     return formatDateToISO(lastDayOfLastMonth);
  //   };

  //   const getDateDaysAgo = (date, days) => {
  //     const result = new Date(date);
  //     result.setDate(date.getDate() - days);
  //     result.setHours(0, 0, 0, 0);
  //     return formatDateToISO(result);
  //   };

  //   const today = new Date();
  //   const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
  //   const endOfToday = new Date(); // Current time

  //   switch (selectedDateRange) {
  //     case 'Today':
  //       datefilter = `filters[createdAt][$gte]=${formatDateToISO(
  //         startOfToday
  //       )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
  //       break;

  //     case 'Yesterday':
  //       const yesterday = new Date();
  //       yesterday.setDate(today.getDate() - 1);
  //       datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
  //       break;

  //     case 'This week':
  //       datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
  //       break;

  //     case 'Last week':
  //       const lastWeekStart = new Date(today);
  //       lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
  //       datefilter = `filters[createdAt][$gte]=${formatDateToISO(
  //         lastWeekStart
  //       )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
  //       break;

  //     case 'This month':
  //       datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
  //       break;

  //     case 'Last month':
  //       datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
  //         today
  //       )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
  //       break;

  //     case 'Last 3 month':
  //       const threeMonthsAgo = new Date(today);
  //       threeMonthsAgo.setMonth(today.getMonth() - 3);
  //       datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
  //       break;

  //     case 'Last 6 month':
  //       const sixMonthsAgo = new Date(today);
  //       sixMonthsAgo.setMonth(today.getMonth() - 6);
  //       datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
  //       break;

  //     default: // Or handle the default case as needed
  //       datefilter = '';
  //       break;
  //   }

  //   switch (selectedUpdatedDateRange) {
  //     case 'Today':
  //       updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
  //         startOfToday
  //       )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
  //       break;

  //     case 'Yesterday':
  //       updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
  //       break;

  //     case 'This week':
  //       updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
  //       break;

  //     case 'Last week':
  //       const lastWeekStart = new Date(today);
  //       lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
  //       updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
  //         lastWeekStart
  //       )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
  //       break;

  //     case 'This month':
  //       updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
  //       break;

  //     case 'Last month':
  //       updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
  //         today
  //       )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
  //       break;

  //     case 'Last 3 month':
  //       const threeMonthsAgo = new Date(today);
  //       threeMonthsAgo.setMonth(today.getMonth() - 3);
  //       updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
  //       break;

  //     case 'Last 6 month':
  //       const sixMonthsAgo = new Date(today);
  //       sixMonthsAgo.setMonth(today.getMonth() - 6);
  //       updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
  //       break;

  //     default: // Or handle the default case as needed
  //       updateddatefilter = '';
  //       break;
  //   }

  //   let response;
  //   if (selectedOption == 'Trash') {
  //     response = await fetch(
  //       `${ipp}/api/catalogues?populate=*&pagination[page]=${page}&filters[Status][$ne]=Trash&sort[0]=id:desc${buyerNameFilter}${createdByFilter}${searchQryFilter}${updateddatefilter}`
  //     );
  //   } else {
  //     response = await fetch(
  //       `${ipp}/api/catalogues?populate=*&pagination[page]=${page}&sort[0]=id:desc${buyerNameFilter}${createdByFilter}${statusFilter}${searchQryFilter}${updateddatefilter}`
  //     );
  //   }

  //   setProgress(60);
  //   const json = await response.json();

  //   setMeta123(json.meta);
  //   setIsLoading(false);
  //   setProgress(100);
  //   if (isLoading1) {
  //     return;
  //   }

  //   setIsLoading1(true);
  //   const productResponse = await fetch(
  //     `${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${pageedit}`
  //   );
  //   const productJson = await productResponse.json();
  //   setMetaEdit(productJson.meta);
  //   setProductData(productJson.data);
  //   const updatedCatalogueData = json.data.map(item => ({
  //     ...item,
  //     itemCount: item.attributes.CatalogueProduct.length
  //   }));
  //   // console.log("updatedCatalogueData", updatedCatalogueData)
  //   setFilteredData(updatedCatalogueData);
  //   setCatalogueData(updatedCatalogueData);
  //   // console.log(updatedCatalogueData);

  //   setIsLoading1(false);
  // };


  const handleDeleteRow = async rowId => {
    try {
      const response = await fetch(`${ipp}/api/catalogues/${rowId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        const updatedData = cataloguedata.filter(row => row.id !== rowId);
        setCatalogueData(updatedData);
        fetchDatat();
      } else {
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'inActive', label: 'Inactive' }
  ];

  const handleStatusChange = async (catalogId, newStatus) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...cataloguedata,
        Status: newStatus
      })
    );

    fetch(`${ipp}/api/catalogues/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        fetchDatat();
      })
      .catch(error => {
        console.error(error);
      });
    setStatusPickerVisible(false);
  };

  const handleTrashRow = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...cataloguedata,
        Status: 'Trash'
      })
    );
    fetch(`${ipp}/api/catalogues/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        fetchDatat();
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleRestoreRow = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...cataloguedata,
        Status: 'Active'
      })
    );
    fetch(`${ipp}/api/catalogues/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        fetchDatat();
      })
      .catch(error => {
        console.error(error);
      });
  };
  const autoDeleteRow = rowId => {
    setTimeout(() => {
      handleDeleteRow(rowId);
    }, 600000);
  };

  useEffect(() => {
    cataloguedatat.forEach(row => {
      autoDeleteRow(row.id);
    });
    setTimeout(() => {
      fetchDatat();
    }, 600000);
  }, [cataloguedatat]);

  useEffect(() => {
    fetchDatat();
  }, []);
  const fetchDatat = async () => {
    if (isLoadingt) {
      return;
    }
    setIsLoadingt(true);
    const response = await fetch(
      `${ipp}/api/catalogues?populate=*&pagination[page]=1&filters[Status][$eq]=Trash`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ipp}/api/catalogues?populate=*&pagination[page]=${page}&filters[Status][$eq]=Trash`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setCatalogueDatat(allData);
    setIsLoadingt(false);
    const updatedCatalogueData = allData.map(item => ({
      ...item,
      itemCount: item.attributes.CatalogueProduct.length
    }));
    setCatalogueDatat(updatedCatalogueData);
  };
  const [stt, setStt] = useState(false);
  useEffect(() => {
    fetchData1();
  }, []);
  const fetchData1 = async () => {
    const response = await fetch(`${ipp}/api/company-details?populate=*`);
    const json = await response.json();
    const extractedData = json.data[0].attributes;
    setStt(extractedData.BulkCatalogue || false);
    setData1(json.data);
  };
  useEffect(() => {
    fetchData3();
  }, []);
  const [allBuyerData, setAllBuyerData] = useState([]);

  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ipp}/api/buyer-details`);
      const json = await response.json();
      const data = json.data ?? [];

      setAllBuyerData(data);

      const uniqueCompanyNames = Array.from(
        new Set(data.map(item => item.attributes.companynm?.trim() || ''))
      );

      const processedBuyerCompanyNameData = uniqueCompanyNames.map(companyName => ({
        label: companyName,
        value: companyName
      }));

      setBuyeerCompNamedata(processedBuyerCompanyNameData);

      const initialFiltered = selectedBuyerCompName
        ? data.filter(
          item =>
            item.attributes.companynm?.trim().toLowerCase() ===
            selectedBuyerCompName.trim().toLowerCase()
        )
        : data;

      const processedBuyerNameData = initialFiltered.map(item => ({
        label: item?.attributes?.buyernm || '',
        value: item?.attributes?.buyernm || '',
        company: item?.attributes?.companynm?.trim() || ''
      }));

      setBuyeerdata(processedBuyerNameData);

    } catch (error) {
      console.error('Error fetching buyer data:', error);
    }
  };

  useEffect(() => {
    if (!allBuyerData || allBuyerData.length === 0) return;

    const filtered = selectedBuyerCompName
      ? allBuyerData.filter(
        item =>
          item.attributes.companynm?.trim().toLowerCase() ===
          selectedBuyerCompName.trim().toLowerCase()
      )
      : allBuyerData;

    const processed = filtered.map(item => ({
      label: item?.attributes?.buyernm || '',
      value: item?.attributes?.buyernm || '',
      company: item?.attributes?.companynm?.trim() || ''
    }));

    setBuyeerdata(processed);
  }, [selectedBuyerCompName, allBuyerData]);

  const handleSearch = value => {
    setSearchQuery(value);
    const matchingProductsCount = cataloguedata.filter(item => {
      const productName = item.attributes.catalogueName.toLowerCase();
      const aliasCode = item.attributes.BuyerCompany.toLowerCase();
      const ContNo = item.attributes.CatalogueCode.toLowerCase();

      return (
        productName.includes(value.toLowerCase()) ||
        aliasCode.includes(value.toLowerCase()) ||
        ContNo.includes(value.toLowerCase())
        // ... other conditions ...
      );
    }).length;
    setFoundProductCount(matchingProductsCount);
  };

  const handleSearch1 = value => {
    setSearchQuery1(value);
  };
  const [updateCatalogue, setUpdateCatalogue] = useState('');

  const handleMoreIconClick = async rowData => {
    const catalogueProducts = rowData.attributes.CatalogueProduct;
    setCataname(rowData.attributes.catalogueName);
    const mappedProducts = catalogueProducts.map(item => ({
      id: parseInt(item.CatalogProduct, 10), // product ID
      productId: item.aliascd // alias code
    }));
    setProductAlldata(mappedProducts); // now holds array of objects with both values
    setIsModalOpen(true);
    setUpdateCatalogue(rowData.attributes.CatalogueCode);
  };
  useEffect(() => {
    if (productalldata.length) {
      fetchProducts(productalldata);
    }
  }, [productalldata, pageview]);

  const fetchProducts = async matchingIds => {
    try {
      const productIdsQueryParam = matchingIds.map(p => `filters[id][$in][]=${p.id}`).join('&');
      const productIdFilters = productalldata
        .filter(p => p.productId) // only if aliascd exists
        .map(p => `filters[ProductId][$in][]=${encodeURIComponent(p.productId)}`)
        .join('&');
      const filterQuery = [productIdsQueryParam, productIdFilters].filter(Boolean).join('&');
      const response = await fetch(
        `${ipp}/api/products?${filterQuery}&populate=*&sort[0]=id:desc&pagination[page]=${pageview}`
      );
      const responsevar = await fetch(
        `${ipp}/api/variant-products?sort[0]=id:asc&${filterQuery}&populate=*`
      );
      const json = await response.json();
      const jsonvar = await responsevar.json();
      const newPdata = [...json.data, ...jsonvar.data];
      setFetchedProducts(newPdata);
      setMetaView(json.meta);
      setCurrentPage(pageview);
      // fetchAndProcessCatalogueData()
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      let tempMeta = metaview;
      if (tempMeta?.pagination) {
        tempMeta.pagination.total = 0;
      }
      setMetaView(tempMeta);
      setFetchedProducts([]);
    }
  }, [isModalOpen]);
  const [trash, setTrash] = useState(false);
  const handleOpenTrash = () => setTrash(true);
  const handleCloseTrash = () => setTrash(false);

  const [editingCollection, setEditingCollection] = useState(null);
  const [editedProducts, setEditedProducts] = useState([]);
  const [isModalOpenp, setIsModalOpenp] = useState(false);
  const [loadingadd, setLoadingAdd] = useState(false);
  const navigate = useNavigate();

  const handleEdit = collection => {
    const productstring = collection.attributes.CatalogueProduct.map(
      product => product.CatalogProduct
    ).join(','); // Join them with '0' as the separator
    navigate(
      `/${ugr}/editDetails?selectedItems=${productstring}&updateCatalogue=${collection.attributes.CatalogueCode}`
    );
    setEditingCollection(collection);
    setIsModalOpenp(true);
    setEditedProducts(collection.attributes.CatalogueProduct);
  };

  const handleSave = async collection => {
    try {
      setLoadingAdd(true);
      const response = await fetch(`${ipp}/api/catalogues/${collection.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { CatalogueProduct: editedProducts } })
      });

      if (response.ok) {
        fetchData();
        setLoadingAdd(false);
        setEditingCollection(null);
        setEditedProducts([]);
      } else {
        const errorResponse = await response.json();
        console.error('Error saving collection:', errorResponse);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setEditingCollection(null);
    setEditedProducts([]);
    setIsModalOpen(false);
  };
  const handleEscKey = event => {
    if (event.key === 'Escape') {
      setEditingCollection(null);
      setEditedProducts([]);
      setIsModalOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);
  const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(true);
  const handleCheckboxChange = (rowId, checked) => {
    setEditedProducts(prevProducts => {
      if (checked) {
        const product = vardata.find(item => item.id == rowId);
        if (product) {
          return [
            ...prevProducts,
            {
              CatalogProduct: String(product.id),
              CatalogCode: editingCollection.attributes.CatalogueCode,
              catcd: product.attributes.CategoryCode,
              prodtypecd: product.attributes.ProductTypeCode,
              aliascd: product.attributes.ProductId,
              productname: product.attributes.ProductName,
              description: product.attributes.Description,
              unit: product.attributes.SizeUnit,
              len: product.attributes.Length,
              finish: product.attributes.FinishName,
              wid: product.attributes.Width,
              thick: product.attributes.Height,
              color: product.attributes.ColorName,
              netwgt: product.attributes.NetWeight,
              grswgt: product.attributes.GrossWeight,
              saleprice: product.attributes.SellingPrice,
              currency: product.attributes.SellingPriceCurrency,
              remark: product.attributes.Product_Remark,
              shape: product.attributes.Shape,
              cbm: product.attributes.cbm,
              SizeRange: product.attributes.SizeRange
            }
          ];
        } else {
          console.warn('Product not found in vardata for ID:', rowId);
        }
      } else {
        return prevProducts.filter(product => product.CatalogProduct !== String(rowId));
      }
      return prevProducts;
    });
  };

  const handleProductToggle = productId => {
    setEditedProducts(prevProducts => {
      const isProductIncluded = editedProducts.some(
        item => item.CatalogProduct == String(productId.id)
      );

      let updatedProducts;
      if (isProductIncluded) {
        updatedProducts = prevProducts.filter(item => item.CatalogProduct != String(productId.id));
      } else {
        updatedProducts = [
          ...prevProducts,
          {
            CatalogProduct: String(productId.id),
            CatalogCode: editingCollection.attributes.CatalogueCode,
            catcd: productId.attributes.CategoryCode,
            prodtypecd: productId.attributes.ProductTypeCode,
            aliascd: productId.attributes.ProductId,
            productname: productId.attributes.ProductName,
            description: productId.attributes.Description,
            unit: productId.attributes.SizeUnit,
            len: productId.attributes.Length,
            finish: productId.attributes.FinishName,
            wid: productId.attributes.Width,
            thick: productId.attributes.Height,
            color: productId.attributes.ColorName,
            netwgt: productId.attributes.NetWeight,
            grswgt: productId.attributes.GrossWeight,
            saleprice: productId.attributes.SellingPrice,
            currency: productId.attributes.SellingPriceCurrency,
            remark: productId.attributes.Product_Remark,
            shape: productId.attributes.Shape,
            cbm: productId.attributes.cbm,
            SizeRange: productId.attributes.SizeRange
          }
        ];
      }

      setIsAnyCheckboxSelected(updatedProducts.length > 0);
      return updatedProducts;
    });
  };

  const [isStatusPickerVisible, setStatusPickerVisible] = useState({});
  const toggleStatusPicker = rowId => {
    setStatusPickerVisible(prevState => ({
      ...prevState,
      [rowId]: !prevState[rowId]
    }));
  };
  function getStatusButtonClass(status) {
    if (status === 'inActive') {
      return 'inactive-button';
    } else if (status === 'Active') {
      return 'active-button';
    } else if (status === 'Draft') {
      return 'draft-button';
    }
  }
  useEffect(() => {
    fetchDataname();
  }, []);
  const fetchDataname = async () => {
    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(`${ipp}/api/user-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      const seenNames = new Set(); // To track unique Full_Name values

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ipp}/api/user-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();

        const processedData = pageJson.data
          .map(item => ({
            label: item.attributes.Full_Name,
            value: item.attributes.Full_Name
          }))
          .filter(item => {
            // Filter out duplicates by checking if the name has already been seen
            const isDuplicate = seenNames.has(item.value);
            if (!isDuplicate) {
              seenNames.add(item.value); // Add to Set if it's unique
              return true;
            }
            return false;
          });

        allData.push(...processedData);
      }

      setFullname(allData);
      setIsLoadingc(false);
    } catch (error) {
      console.error('Error fetching Name data:', error);
    }
  };

  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [attachment, setAttachment] = useState<{
    filename: string | null;
    contentType: string | null;
    content: string | null
  }>({
    filename: null,
    contentType: null,
    content: null
  });

  const handleAttachmentChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        const base64Content = event.target.result.split(',')[1];
        setAttachment({
          filename: file.name,
          contentType: file.type,
          content: base64Content
        });
      };
      reader.readAsDataURL(file);
    }
  };
  const [loading, setLoading] = useState(false);

  const sendemail = async () => {
    // const endpoint = `${ipp}/api/email`;
    const endpoint = `${ipp}/api/send-mail`;
    // const data = {
    //   to: to,
    //   subject: subject,
    //   html: message,
    //   attachments: [
    //     {
    //       filename: attachment.filename || '', // Use empty string if filename is null
    //       content: attachment.content || '', // Use empty string if content is null
    //       encoding: 'base64'
    //     }
    //   ]
    // };
    const attachments = [];
    if (attachment.filename && attachment.content) {
      attachments.push({
        filename: attachment.filename,
        contentType: attachment.contentType || 'application/octet-stream', // Provide proper content type
        base64: attachment.content // Use the actual base64 content, not the string 'base64'
      });
    }

    const data = {
      toEmail: to,
      subject: subject,
      message: message,
      attachments: attachments
    };
    try {
      setLoading(true);
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        setLoading(false);
        handleClose();
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.error('Failed to send email');
        toaster.push(
          <Message showIcon type="error">
            Failed to send email
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ipp}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ipp}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setFinShow(json.data[0].attributes.setFinish);
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [vardata, setVarData] = useState([]);
  const fetchDataVData = async id => {
    try {
      const response = await fetch(
        `${globalIP}/api/variant-products?filters[Variant_Id][$eq]=${id}&populate=*`
      );
      const json = await response.json();
      setVarData(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [varOpen, setVarOpen] = useState(false);
  const openVardata = id => {
    setVarOpen(true);
    fetchDataVData(id);
  };

  const columns = [
    {
      key: 'ProductId',
      label: 'Assign',
      width: 100,
      fixed: true,
      headerCell: (
        <Table.HeaderCell>
          <b>Assign</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => (
            <Checkbox
              checked={editedProducts
                ?.map(item => item.CatalogProduct)
                .includes(String(rowData.id))}
              onChange={() => handleProductToggle(rowData)}
            />
          )}
        </Cell>
      )
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ipp}${rowData.attributes.CoverImage.data.attributes.url}`
                )}
              >
                <img
                  src={`${ipp}${rowData.attributes.CoverImage.data.attributes.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-12px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.Description}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            sizeshow
              ? rowData.attributes.SizeRange
              : `${rowData.attributes.Length} x ${rowData.attributes.Width} x ${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
          }
        </Cell>
      )
    },
    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.FinishName}</Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ColorName}</Cell>
    },
    {
      key: 'Action',
      label: `Action`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            rowData.attributes.Variant === true ? (
              <>
                <Button
                  appearance="ghost"
                  color="cyan"
                  onClick={() => openVardata(rowData.attributes.ProductCode)}
                >
                  Variant
                </Button>
              </>
            ) : (
              <>
                <p>-</p>
              </>
            )
          }
        </Cell>
      )
    }
  ];
  const [columnKeys, setColumnKeys] = useState(columns.map(column => column.key));
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);
  const handleChangeLimit = () => {
    setPage(1);
  };

  const handleChangeLimitforviw = () => {
    setPageView(1);
  };
  const handleChangeLimitEdit = () => {
    setPageEdit(1);
  };

  const [openMenu, setOpenMenu] = useState(false);

  const handleCheckAllT = checked => {
    if (!checked) {
      // Add products to editedProducts that are not already present
      const newProducts = vardata
        .map(product => ({
          CatalogProduct: String(product.id),
          CatalogCode: product.attributes.CatalogueCode,
          catcd: product.attributes.CategoryCode,
          prodtypecd: product.attributes.ProductTypeCode,
          aliascd: product.attributes.ProductId,
          productname: product.attributes.ProductName,
          description: product.attributes.Description,
          unit: product.attributes.SizeUnit,
          len: product.attributes.Length,
          finish: product.attributes.FinishName,
          wid: product.attributes.Width,
          thick: product.attributes.Height,
          color: product.attributes.ColorName,
          netwgt: product.attributes.NetWeight,
          grswgt: product.attributes.GrossWeight,
          saleprice: product.attributes.SellingPrice,
          currency: product.attributes.SellingPriceCurrency,
          remark: product.attributes.Product_Remark,
          shape: product.attributes.Shape,
          cbm: product.attributes.cbm,
          SizeRange: product.attributes.SizeRange
        }))
        .filter(
          newProduct =>
            !editedProducts.some(
              existingProduct =>
                existingProduct.CatalogProduct === String(newProduct.CatalogProduct)
            )
        );
      setEditedProducts(prevState => [...prevState, ...newProducts]);
    }
    if (checked) {
      setEditedProducts(prevState =>
        prevState.filter(
          product =>
            !vardata.some(row => {
              return row.id === parseInt(product.CatalogProduct);
            })
        )
      );
    }
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 330; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);

  const [showDimm, setShowDimm] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenDimm = row => {
    setSelectedRow(row);
    setShowDimm(true);
  };
  const handleCloseDimm = () => setShowDimm(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const handleCheckboxChange1 = (rowId, checked) => {
    if (checked) {
      setSelectedRowIds(prevSelectedRowIds => [...prevSelectedRowIds, rowId]);
    } else {
      setSelectedRowIds(prevSelectedRowIds =>
        prevSelectedRowIds.filter(selectedRowId => selectedRowId !== rowId)
      );
    }
  };
  const handleCheckAll = (value, checked) => {
    if (checked) {
      // Select all items
      setSelectedRowIds(filteredData.map(row => row.id));
    } else {
      // Deselect all items
      setSelectedRowIds([]);
    }
  };

  const handleGenerateLink = (rowData) => {
    console.log(rowData)
    setOpenGenerateSlider(true)
    setSelectedCatalogueCode(rowData?.attributes?.CatalogueCode ?? "")
  }
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack
          className="table-toolbar mange-head"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="row" alignItems="flex-start" spacing={141}>
                <h3 className="title">Manage Catalogue</h3>
                <div onClick={() => setOpenMenu(!openMenu)}>
                  <MenuIcon className="burgerMenu1" />
                </div>
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Manage</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} className={openMenu ? 'mange-item' : 'mange-search'}>
              <Stack direction="column" alignItems="flex-start">
                <label>Search</label>
                <InputGroup inside>
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                    className="pdt-srch"
                  />
                  <InputGroup.Addon>
                    <SearchIcon style={{ cursor: 'pointer' }} />
                  </InputGroup.Addon>
                </InputGroup>
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>Buyer Company</label>
                <SelectPicker
                  data={buyeerCompNamedata}
                  onChange={value => {
                    setSelectedBuyerCompName(value);
                    setPage(1);
                    setFilterApplied(true);
                    const buyerFilteredCount = cataloguedata.filter(item => {
                      const buyerMatch = !value || item.attributes.BuyerCompany === value;
                      return buyerMatch;
                    }).length;

                    setFoundProductCount(buyerFilteredCount);
                  }}
                  onClean={() => {
                    setSelectedBuyerCompName('');
                    setFilterApplied(false);
                  }}
                  size="md"
                  appearance="default"
                  placeholder={"Buyer Company"}
                  style={{ width: 200 }}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>{`${label[0]?.attributes.BuyerName}`}</label>
                <SelectPicker
                  data={buyeerdata}
                  onChange={value => {
                    setSelectedBuyerName(value);
                    setPage(1);
                    setFilterApplied(true);
                    const buyerFilteredCount = cataloguedata.filter(item => {
                      const buyerMatch = !value || item.attributes.BuyerName === value;
                      return buyerMatch;
                    }).length;

                    setFoundProductCount(buyerFilteredCount);
                  }}
                  onClean={() => {
                    setSelectedBuyerName('');
                    setFilterApplied(false);
                  }}
                  size="md"
                  appearance="default"
                  placeholder={`${label[0]?.attributes.BuyerName}`}
                  style={{ width: 200 }}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>Created By</label>
                <SelectPicker
                  data={fullname}
                  onChange={value => {
                    setUserName(value);
                    setPage(1);
                    setFilterApplied(true);
                    const userFilteredCount = cataloguedata.filter(item => {
                      const userMatch = item.attributes.CreateBy == userName;
                      return userMatch;
                    });

                    setFoundProductCount(userFilteredCount.length);
                  }}
                  onClean={() => {
                    setUserName('');
                    setFilterApplied(false);
                  }}
                  size="md"
                  appearance="default"
                  placeholder="All User"
                  style={{ width: 200 }}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>Status</label>
                <SelectPicker
                  value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues ', value: 'Trash' },
                    { label: 'Inactive ', value: 'inActive' },
                    { label: 'Active', value: 'Active' },
                    { label: 'Draft', value: 'Draft' }
                  ]}
                  size="md"
                  appearance="default"
                  placeholder="Status"
                  style={{ width: 150 }}
                  cleanable={false}
                />
              </Stack>
              <AddedOnFIlter
                {...{
                  showboth: 'updated',
                  showLable: true,
                  AddedOn,
                  selectedDateRange: [],
                  handleDatechange: () => { },
                  selectedUpdatedDateRange,
                  handleUpdatedDatechange
                }}
              />
            </Stack>
          </Stack>
          <Stack className={openMenu ? 'mange-item' : 'mange-search'} spacing={5}>
            {data1[0]?.attributes?.BulkCatalogue && (
              <Dropdown title="Action" active>
                <Dropdown.Item
                  onClick={() => setDeleteModal(true)}
                  disabled={selectedRowIds.length === 0}
                >
                  Delete Catalogue
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setActiveInModal(true)}
                  disabled={selectedRowIds.length === 0}
                >
                  Active/Inactive
                </Dropdown.Item>
                <Link
                  to={{
                    pathname: `/${ugr}/generate-catalogue`,
                    search: `?bulkid=${selectedRowIds}`
                  }}
                >
                  <Dropdown.Item disabled={selectedRowIds.length === 0}>Download</Dropdown.Item>
                </Link>
              </Dropdown>
            )}
            <Badge content={cataloguedatat?.length}>
              <Button appearance="subtle" active onClick={handleOpenTrash}>
                Trash
              </Button>
            </Badge>
          </Stack>
        </Stack>

        <Divider className="divide " />
        <div className="mng-ctl-row">
          <Panel>
            <>
              <Table
                height={tableHeight}
                className="mange-tbl"
                data={filteredData}
                loading={isLoading1}
                bordered
                cellBordered
                wordWrap="break-word"
              >
                <Table.Column width={80} align="center" fixed>
                  <HeaderCell>
                    <b>Sr. No.</b>
                  </HeaderCell>
                  <Cell>{(_, rowIndex) => (page - 1) * 25 + rowIndex + 1}</Cell>
                </Table.Column>

                {stt && <Table.Column width={60} align="center">
                  <HeaderCell style={{ padding: 0 }}>
                    <div style={{ lineHeight: '40px' }}>
                      {stt && (
                        <Checkbox
                          inline
                          checked={selectedRowIds.length === filteredData.length}
                          indeterminate={
                            selectedRowIds.length > 0 && selectedRowIds.length < filteredData.length
                          }
                          onChange={handleCheckAll}
                        />
                      )}
                    </div>
                  </HeaderCell>

                  <MaybeCheckCell
                    show={stt}
                    dataKey="id"
                    checkedKeys={selectedRowIds}
                    onChange={(rowId: any, checked: boolean) =>
                      handleCheckboxChange1(rowId, checked)
                    }
                  />
                </Table.Column>}

                <Column width={150}>
                  <HeaderCell>
                    <b>Catalogue Name</b>
                  </HeaderCell>
                  <Cell>
                    {rowData => (
                      <>
                        <div style={{ display: 'grid' }}>
                          {rowData.attributes.catalogueName}

                          {rowData.id === editingCollection?.id ? (
                            <div>
                              <Modal
                                size="full"
                                open={isModalOpenp}
                                onClose={() => setIsModalOpenp(false)}
                                backdrop="static"
                                className="modal"
                              >
                                <FlexboxGrid justify="space-between">
                                  <FlexboxGrid.Item colspan={6}>
                                    <b>Add/Remove Products</b>
                                  </FlexboxGrid.Item>
                                  <FlexboxGrid.Item colspan={6}>
                                    <InputGroup inside>
                                      <Input
                                        placeholder="Search"
                                        type="text"
                                        value={searchQuery1}
                                        onChange={value => handleSearch1(value)}
                                      />
                                      <InputGroup.Addon>
                                        <SearchIcon />
                                      </InputGroup.Addon>
                                    </InputGroup>
                                  </FlexboxGrid.Item>
                                </FlexboxGrid>
                                <Modal.Body>
                                  {isLoading1 ? (
                                    <Loader size="sm" speed="fast" center content="Loading..." />
                                  ) : (
                                    <>
                                      <Table
                                        data={productData.filter(item => {
                                          const ProductName = item.attributes.ProductName
                                            ? item.attributes.ProductName.toLowerCase()
                                            : '';
                                          const AliasCode = item.attributes.ProductId
                                            ? item.attributes.ProductId.toLowerCase()
                                            : '';
                                          const ColorName = item.attributes.ColorName
                                            ? item.attributes.ColorName.toLowerCase()
                                            : '';
                                          const FinishName = item.attributes.FinishName
                                            ? item.attributes.FinishName.toLowerCase()
                                            : '';

                                          return (
                                            ProductName.includes(searchQuery1.toLowerCase()) ||
                                            AliasCode.includes(searchQuery1.toLowerCase()) ||
                                            ColorName.includes(searchQuery1.toLowerCase()) ||
                                            FinishName.includes(searchQuery1.toLowerCase())
                                          );
                                        })}
                                        height={500}
                                        wordWrap
                                        rowKey="id"
                                        cellBordered
                                        bordered
                                      >
                                        {columns.map(column => {
                                          if (columnKeys.includes(column.key)) {
                                            const { key, label, headerCell, cell, ...rest } =
                                              column;
                                            return (
                                              <Table.Column {...rest} key={key} align="center">
                                                {headerCell || (
                                                  <CustomHeaderCell>{label}</CustomHeaderCell>
                                                )}
                                                {cell || <CustomCell dataKey={key} />}
                                              </Table.Column>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Table>
                                      <div style={{ padding: 20 }}>
                                        <Pagination
                                          prev
                                          next
                                          first
                                          last
                                          ellipsis
                                          boundaryLinks
                                          maxButtons={5}
                                          limit={25}
                                          size="xs"
                                          layout={['-', 'pager', 'skip']}
                                          total={metaedit?.pagination?.total || 0}
                                          activePage={pageedit}
                                          onChangePage={setPageEdit}
                                          onChangeLimit={handleChangeLimitEdit}
                                        />
                                      </div>
                                    </>
                                  )}
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button appearance="subtle" active onClick={handleCancel}>
                                    Cancel
                                  </Button>
                                  <Button
                                    onClick={() => handleSave(editingCollection)}
                                    appearance="primary"
                                    color="cyan"
                                    disabled={!isAnyCheckboxSelected}
                                    loading={loadingadd}
                                  >
                                    Save
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          ) : (
                            <span style={{ fontSize: '12px', color: 'gray' }}>
                              {rowData.itemCount} Products
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </Cell>
                </Column>
                <Column width={120} align="center">
                  <HeaderCell>
                    <b>Buyer Company</b>
                  </HeaderCell>
                  <Cell>
                    {rowData =>
                      rowData.attributes?.BuyerCompany
                        ? rowData.attributes.BuyerCompany
                        : rowData.attributes?.CPerson
                    }
                  </Cell>
                </Column>
                <Column width={100} align="center">
                  <HeaderCell>
                    <b>{`${label[0]?.attributes.BuyerName}`}</b>
                  </HeaderCell>
                  <Cell>
                    {rowData =>
                      rowData.attributes?.BuyerName
                        ? rowData.attributes.BuyerName
                        : rowData.attributes?.CPerson
                    }
                  </Cell>
                </Column>
                <Column width={120}>
                  <HeaderCell>
                    <b>Created By</b>
                  </HeaderCell>
                  <Cell>
                    {rowData =>
                      rowData.attributes?.CreateBy
                        ? rowData.attributes.CreateBy
                        : rowData.attributes?.CreateBy
                    }
                  </Cell>
                </Column>
                <Column width={60} align="center">
                  <HeaderCell>
                    <b>View</b>
                  </HeaderCell>
                  <Cell>
                    {rowData => (
                      <>
                        <Whisper
                          controlId="control-id-hover"
                          trigger="hover"
                          speaker={<Tooltip>View Products</Tooltip>}
                        >
                          <IconButton
                            size="xs"
                            icon={<VisibleIcon />}
                            active
                            onClick={() => handleMoreIconClick(rowData)}
                            style={{ marginRight: '10px' }}
                          />
                        </Whisper>
                      </>
                    )}
                  </Cell>
                </Column>
                <Column width={100} align="center">
                  <HeaderCell>
                    <b>Status</b>
                  </HeaderCell>
                  <Cell dataKey={'attributes.Status'}>
                    {rowData => (
                      <Button
                        className={getStatusButtonClass(rowData.attributes.Status)}
                        style={{ width: 'auto' }}
                        size='sm'
                      >
                        {rowData.attributes.Status}
                      </Button>
                    )}
                  </Cell>
                </Column>
                <Column width={250} align="left">
                  <HeaderCell>
                    <b>Action</b>
                  </HeaderCell>
                  <Table.Cell>
                    {rowData => {
                      return (
                        <>
                          <Stack>
                            {(user.CATaccessPPT === true || user.Category === 'Admin') && (
                              <>
                                {rowData.attributes.Status === 'Active' && (
                                  <Whisper followCursor speaker={<Tooltip>Download</Tooltip>}>
                                    <Link
                                      to={{
                                        pathname: `/${ugr}/generate-catalogue1`,
                                        search: `?id=${rowData.id}&cataloguename=${rowData.attributes.catalogueName}&cataloguecode=${rowData.attributes.CatalogueCode}`
                                      }}
                                    >
                                      <IconButton
                                        size="xs"
                                        icon={<SortDownIcon />}
                                        active
                                        style={{ marginRight: '10px' }}
                                      />
                                    </Link>
                                  </Whisper>
                                )}
                              </>
                            )}
                            {(user.CATupdate === true || user.Category === 'Admin') && (
                              <>
                                {!editingCollection || rowData.id !== editingCollection.id ? (
                                  <Whisper
                                    followCursor
                                    speaker={<Tooltip>Add/Remove Products</Tooltip>}
                                  >
                                    <IconButton
                                      style={{ marginRight: '10px' }}
                                      icon={<EditIcon />}
                                      size="xs"
                                      active
                                      onClick={() => handleEdit(rowData)}
                                    />
                                  </Whisper>
                                ) : (
                                  <>
                                    <IconButton
                                      style={{ marginRight: '10px' }}
                                      size="xs"
                                      icon={<CheckIcon />}
                                      active
                                      onClick={() => handleSave(rowData)}
                                      disabled={!isAnyCheckboxSelected}
                                    />

                                    <IconButton
                                      style={{ marginRight: '10px' }}
                                      size="xs"
                                      icon={<CloseIcon />}
                                      active
                                      onClick={() => handleCancel()}
                                    />
                                  </>
                                )}
                              </>
                            )}
                            {(user.CATModifySts === true || user.Category === 'Admin') && (
                              <>
                                <Whisper followCursor speaker={<Tooltip>Active/Inactive</Tooltip>}>
                                  <IconButton
                                    size="xs"
                                    icon={<MoreIcon />}
                                    active
                                    style={{ marginRight: '10px' }}
                                    onClick={() => toggleStatusPicker(rowData.id)}
                                  />
                                </Whisper>
                                {isStatusPickerVisible[rowData.id] && ( // Render SelectPicker if isVisible is true
                                  <SelectPicker
                                    data={statusOptions}
                                    value={rowData.attributes.Status}
                                    searchable={false}
                                    onChange={newStatus =>
                                      handleStatusChange(rowData.id, newStatus)
                                    }
                                    style={{ width: 120, marginTop: '-8px', marginRight: '10px' }}
                                    cleanable={false}
                                    placement="auto"
                                    size="md"
                                  />
                                )}
                              </>
                            )}
                            {rowData.attributes.Status === 'Active' && ( // Check if status is 'Active'
                              <Whisper followCursor speaker={<Tooltip>Email</Tooltip>}>
                                <IconButton
                                  size="xs"
                                  icon={<EmailIcon />}
                                  active
                                  style={{ marginRight: '10px', color: 'red' }}
                                  onClick={() =>
                                    handleOpen(
                                      'sm',
                                      rowData.attributes.BuyerEmail,
                                      rowData.attributes.BuyerCompany
                                    )
                                  }
                                />
                              </Whisper>
                            )}
                            <WhatsApp {...{ rowData, imger }} />
                            <Whisper followCursor speaker={<Tooltip>Generate Link</Tooltip>}>
                              <AntdButton icon={<LinkOutlined />} onClick={() => handleGenerateLink(rowData)} disabled={rowData.attributes.Glink}
                                style={{ marginLeft: "10px", cursor: "pointer", height: "27px", width: "27px" }} />
                            </Whisper>
                          </Stack>
                        </>
                      );
                    }}
                  </Table.Cell>
                </Column>
                {(user.CATBuyerAct === true || user.Category === 'Admin') && (
                  <Column width={150} align="center">
                    <HeaderCell>
                      <b>Buyer Activity</b>
                    </HeaderCell>
                    <Table.Cell>
                      {rowData => {
                        const [isHovered, setIsHovered] = React.useState(true);

                        return (
                          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                            {rowData.attributes.Glink ? (
                              rowData.attributes.LinkStatus === 'Opened' ? (
                                <React.Fragment>
                                  {isHovered ? (
                                    <Button
                                      size="sm"
                                      className="button-hover"
                                      appearance="primary"
                                      color="green"
                                      onMouseEnter={() => setIsHovered(false)}
                                      style={{ width: '100px' }}
                                    >
                                      Opened
                                    </Button>
                                  ) : (
                                    <Button
                                      className="view-activity-link"
                                      onMouseLeave={() => setIsHovered(true)}
                                      color="cyan"
                                      size="sm"
                                      appearance="primary"
                                      style={{ width: '100px' }}
                                    >
                                      <Link
                                        to={`/${ugr}/view-activity?code=${rowData.attributes.CatalogueCode}&catalogueName=${rowData.attributes.catalogueName}&status=${rowData.attributes.Status}`}
                                        style={{ textDecoration: 'none', color: 'white' }}
                                      >
                                        View Activity
                                      </Link>
                                    </Button>
                                  )}
                                </React.Fragment>
                              ) : rowData.attributes.LinkStatus == 'Selected' ? (
                                <React.Fragment>
                                  {isHovered ? (
                                    <Button
                                      size="sm"
                                      className="button-hover"
                                      onMouseEnter={() => setIsHovered(false)}
                                      appearance="primary"
                                      color="yellow"
                                      style={{ width: '100px' }}
                                    >
                                      Selected
                                    </Button>
                                  ) : (
                                    <Button
                                      className="view-activity-link"
                                      onMouseLeave={() => setIsHovered(true)}
                                      color="cyan"
                                      size="sm"
                                      appearance="primary"
                                      style={{ width: '100px' }}
                                    >
                                      <Link
                                        to={`/${ugr}/view-activity?code=${rowData.attributes.CatalogueCode}&catalogueName=${rowData.attributes.catalogueName}&status=${rowData.attributes.Status}`}
                                        style={{ textDecoration: 'none', color: 'white' }}
                                      >
                                        View Activity
                                      </Link>
                                    </Button>
                                  )}
                                </React.Fragment>
                              ) : rowData.attributes.LinkStatus == 'Query Sent' ? (
                                <React.Fragment>
                                  {isHovered ? (
                                    <Button
                                      size="sm"
                                      className="button-hover"
                                      onMouseEnter={() => setIsHovered(false)}
                                      appearance="primary"
                                      color="orange"
                                      style={{ width: '100px' }}
                                    >
                                      Query sent
                                    </Button>
                                  ) : (
                                    <Button
                                      className="view-activity-link"
                                      onMouseLeave={() => setIsHovered(true)}
                                      color="cyan"
                                      size="sm"
                                      appearance="primary"
                                      style={{ width: '100px' }}
                                    >
                                      <Link
                                        to={`/${ugr}/view-activity?code=${rowData.attributes.CatalogueCode}&catalogueName=${rowData.attributes.catalogueName}&status=${rowData.attributes.Status}`}
                                        style={{ textDecoration: 'none', color: 'white' }}
                                      >
                                        View Activity
                                      </Link>
                                    </Button>
                                  )}
                                </React.Fragment>
                              ) : (
                                <Button
                                  size="sm"
                                  appearance="primary"
                                  color="orange"
                                  style={{ width: '100px' }}
                                >
                                  Not Opened
                                </Button>
                              )
                            ) : (
                              <Button
                                appearance="primary"
                                color="red"
                                style={{ width: '100px' }}
                                size="sm"
                              >
                                No link
                              </Button>
                            )}
                          </div>
                        );
                      }}
                    </Table.Cell>
                  </Column>
                )}
                <Column width={170} align="center">
                  <HeaderCell>
                    <b>Controlers</b>
                  </HeaderCell>
                  <Table.Cell>
                    {rowData => {
                      const [copy, setCopy] = useState(false);
                      const handleCopyButtonClick = () => {
                        setCopy(true);
                        setTimeout(() => {
                          setCopy(false);
                        }, 2000);
                      };
                      return (
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                          {(user.CATControlSet === true || user.Category === 'Admin') && (
                            <Whisper
                              followCursor
                              speaker={<Tooltip>Action</Tooltip>}
                              placement="top"
                            >
                              <IconButton
                                size="xs"
                                icon={<GearIcon style={{ fontSize: '15px' }} />}
                                active
                                onClick={() => {
                                  setManageCatlougeOpen(true);
                                  setUpdateClientAuthData(rowData);
                                }}
                                appearance="default"
                              />
                            </Whisper>
                          )}
                          {console.log(rowData?.attributes)}
                          {(user.CATaccessPPT === true || user.Category === 'Admin') && (
                            <CopyToClipboard
                              text={
                                `${data1[0]?.attributes?.GLink}${rowData.attributes.Glink}` || ''
                              }
                            >
                              <Whisper
                                trigger="click"
                                placement={'top'}
                                disabled={rowData.attributes.Glink ? false : true}
                                speaker={
                                  <Tooltip>
                                    {`${data1[0]?.attributes?.GLink}${rowData.attributes.Glink}` ||
                                      null}
                                  </Tooltip>
                                }
                              >
                                <Button
                                  active
                                  appearance="default"
                                  style={{ width: !copy ? '50px' : '70px' }}
                                  size="sm"
                                  onClick={() =>
                                    rowData.attributes.Glink ? handleCopyButtonClick() : null
                                  }
                                >
                                  {!copy ? (rowData.attributes.Glink ? 'Link' : '-') : 'Copied!'}
                                </Button>
                              </Whisper>
                            </CopyToClipboard>
                          )}
                        </div>
                      );
                    }}
                  </Table.Cell>
                </Column>
              </Table>
              <div style={{ padding: 20 }}>
                <Pagination
                  prev
                  next
                  first
                  last
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  limit={25}
                  size="xs"
                  layout={['total', '-', 'pager', 'skip']}
                  total={meta123?.pagination?.total || 0}
                  activePage={page}
                  onChangePage={setPage}
                  onChangeLimit={handleChangeLimit}
                />
              </div>
              {/* View Modal  */}
              {
                <ViewModal
                  header="Catalogue"
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  cataname={cataname}
                  label={label}
                  fetchProducts1={fetchProducts1}
                  tableHeight={tableHeight}
                  currentPage={currentPage}
                  handleOpenDimm={handleOpenDimm}
                  sizeshow={sizeshow}
                  handleChangeLimitforviw={handleChangeLimitforviw}
                  setPageView={setPageView}
                  pageview={pageview}
                  metaview={metaview}
                />
              }
              <Email
                size={size}
                open={open}
                handleClose={handleClose}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                Textarea={Textarea}
                message={message}
                setMessage={setMessage}
                sendemail={sendemail}
                handleAttachmentChange={handleAttachmentChange}
              />
            </>
          </Panel>
        </div>

        <Modal size="full" open={trash} onClose={handleCloseTrash} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Trash Catalogues</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table height={420} data={cataloguedatat} bordered cellBordered>
              <Table.Column width={80} align="center" fixed>
                <HeaderCell>
                  <b>Sr. No.</b>
                </HeaderCell>
                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
              </Table.Column>

              <Column width={300} align="center">
                <HeaderCell>
                  <b>Catalogue Name</b>
                </HeaderCell>
                <Cell dataKey={'attributes.catalogueName'} />
              </Column>
              <Column width={200} align="center">
                <HeaderCell>
                  <b>Buyer Details</b>
                </HeaderCell>
                <Cell dataKey={'attributes.BuyerCompany'} />
              </Column>
              <Column width={150} align="center">
                <HeaderCell>
                  <b>No. of Products</b>
                </HeaderCell>
                <Cell dataKey="itemCount" />
              </Column>

              <Column width={250}>
                <HeaderCell>
                  <b>Buyer Activity</b>
                </HeaderCell>
                <Cell />
              </Column>
              <Column width={250} align="center">
                <HeaderCell>
                  <b>Action</b>
                </HeaderCell>
                <Table.Cell>
                  {rowData => (
                    <>
                      <Whisper followCursor speaker={<Tooltip>Restore</Tooltip>}>
                        <IconButton
                          size="xs"
                          icon={<CloudReflashIcon />}
                          active
                          style={{ marginRight: '10px' }}
                          onClick={() => handleRestoreRow(rowData.id)}
                        />
                      </Whisper>
                      <Whisper followCursor speaker={<Tooltip>Delete</Tooltip>}>
                        <IconButton
                          size="xs"
                          icon={<TrashIcon />}
                          active
                          style={{ marginRight: '10px' }}
                          onClick={() => handleDeleteRow(rowData.id)}
                        />
                      </Whisper>
                    </>
                  )}
                </Table.Cell>
              </Column>
              <Column width={100}>
                <HeaderCell>
                  <b>Status</b>
                </HeaderCell>
                <Cell dataKey={'attributes.Status'}>
                  {rowData => (
                    <Button
                      size='sm'
                      style={{
                        width: '58px',
                        height: '30px',
                        borderRadius: '6px',
                        color: 'white',
                        backgroundColor: 'red'
                      }}
                    >
                      {rowData.attributes.Status}
                    </Button>
                  )}
                </Cell>
              </Column>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseTrash} appearance="primary" color="cyan">
              Done
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={varOpen} onClose={() => setVarOpen(false)} size="lg" backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Variants</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table height={250} data={vardata} bordered cellBordered>
              <Column width={50} align="center">
                <HeaderCell style={{ padding: 0 }}>
                  <div style={{ lineHeight: '40px' }}>
                    <Checkbox
                      inline
                      checked={vardata.every(item =>
                        editedProducts.some(product => product.CatalogProduct == item.id)
                      )}
                      indeterminate={
                        vardata.some(item =>
                          editedProducts.some(product => product.CatalogProduct == item.id)
                        ) &&
                        !vardata.every(item =>
                          editedProducts.some(product => product.CatalogProduct == item.id)
                        )
                      }
                      onChange={checked =>
                        handleCheckAllT(
                          vardata.every(item =>
                            editedProducts.some(product => product.CatalogProduct == item.id)
                          )
                        )
                      }
                    />
                  </div>
                </HeaderCell>
                <Cell>
                  {rowData => {
                    const isChecked = editedProducts
                      .map(item => item.CatalogProduct)
                      .includes(String(rowData.id));
                    return (
                      <Checkbox
                        checked={isChecked}
                        onChange={(rowId, checked) => handleCheckboxChange(rowData.id, checked)}
                      />
                    );
                  }}
                </Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Image</b>
                </HeaderCell>
                <Table.Cell>
                  {rowData => {
                    // Define a function to show the enlarged image on hover
                    const renderTooltip = imageSrc => (
                      <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                        <img
                          src={imageSrc}
                          alt="Product Image"
                          style={{ width: 400, height: 'auto' }}
                        />
                      </Tooltip>
                    );
                    return (
                      <Whisper
                        trigger="hover"
                        placement="right"
                        speaker={renderTooltip(
                          `${ipp}${rowData.attributes.CoverImage.data.attributes.url}`
                        )}
                      >
                        <img
                          src={`${ipp}${rowData.attributes.CoverImage.data.attributes.url}`}
                          alt="Product Image"
                          style={{ width: 50, height: 50, marginTop: '-16px' }}
                        />
                      </Whisper>
                    );
                  }}
                </Table.Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Alias Code</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductId'} />
              </Column>
              <Column flexGrow={1} align="center" fullText>
                <HeaderCell>
                  <b>Description</b>
                </HeaderCell>
                <Cell dataKey={'attributes.Description'} />
              </Column>
              <Column width={200} align="center">
                <HeaderCell>
                  <b>Product Name</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductName'} />
              </Column>
              <Column width={100} align="center">
                <HeaderCell>Finish</HeaderCell>
                <Cell dataKey={'attributes.FinishName'} />
              </Column>
              <Column width={80} align="center">
                <HeaderCell>Color</HeaderCell>
                <Cell dataKey={'attributes.ColorName'} />
              </Column>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setVarOpen(false)} appearance="primary" color="cyan">
              Confirm Selection
            </Button>
          </Modal.Footer>
        </Modal>
        {selectedRow && (
          <ShowDimensionModal {...{ showDimm, handleCloseDimm, selectedRow, finShow, label }} />
        )}

        <Footer />
        <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />
      </Container>
      {manageCatlougeOpen && (
        <ManageCatalogueSlider
          open={manageCatlougeOpen}
          close={() => setManageCatlougeOpen(false)}
          editData={updateClientAuthData}
          handleTrashRow={handleTrashRow}
          setCatalogueData={setCatalogueData}
          setReload={setReload}
        />
      )}
      {delteModal && (
        <DeleteModal
          delteModal={delteModal}
          onClose={() => {
            setDeleteModal(false);
          }}
          selectedRowIds={selectedRowIds}
          setSelectedRowIds={setSelectedRowIds}
          fetchData={fetchData}
          fetchDatat={fetchDatat}
        />
      )}
      {activeInModal && (
        <ActiveInacitve
          activeInModal={activeInModal}
          onClose={() => {
            setActiveInModal(false);
          }}
          selectedRowIds={selectedRowIds}
          setSelectedRowIds={setSelectedRowIds}
          fetchData={fetchData}
        />
      )}
      <GenerateAuthSlider
        open={openGenerateSlider}
        close={() => setOpenGenerateSlider(false)}
        setLinkGenrate={setLinkGenrate}
        setShowCopyButton={setShowCopyButton}
        selectedCatalogueCode={selectedCatalogueCode}
      />
      {console.log(linkGenrate)}
    </>
  );
};

export default ManageCatalogue;
